import { CourseService } from './../../../services/http/business/course/course.service';
import { Component, OnInit } from '@angular/core';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit {
  hide:boolean = false;
  GetFullTimeSession:any;
  constructor(
    private courseService:CourseService,
    private termInfoService:TermInfoService,
  ) { }

  ngOnInit() {
    this.termInfoService.exp.subscribe(res => {
      this.hide = false;
      res.FromNow = false;
      res. RoomFormat = true;
      this.courseService.GetFullTimeSession(res).subscribe(result => {
        this.GetFullTimeSession = result;
      })
    })
  }

}
